import { BinaryType } from "../@types/Binary";
import { Arquitecture } from "./Arquitecture";
import * as fs from "fs";
import * as path from "path";
import * as os from "os";
import { https } from 'follow-redirects';
import * as unzipper from "unzipper";
import { IncomingMessage } from 'http';

class Downloader {
    static get(prefix: string): BinaryType & { name: string; url: string } {
        const arch = new Arquitecture();
        const platform = arch.getPlatform();
        const architecture = arch.getArchitecture();
        
        const platformMap: Record<string, string> = {
            windows: "windows",
            linux: "linux",
            darwin: "macos"
        };
        
        const archMap: Record<string, string> = {
            x86_64: "x64",
            arm64: "arm64"
        };
        
        const plat = platformMap[platform];
        const archSuffix = archMap[architecture];
        
        if (plat && archSuffix) {
            const baseName = `${prefix}-engine-${plat}-${archSuffix}`;
            const binaryName = platform === "windows" ? `${baseName}.exe` : baseName;
            
            const url = `https://github.com/Dbcube/binaries/releases/download/${prefix}-engine/${prefix}-engine-latest-${plat}-${archSuffix}.zip`;
            return {
                name: binaryName,
                url,
                query_engine: binaryName,
                schema_engine: `${prefix}-engine-${plat}-${archSuffix}${platform === "windows" ? ".exe" : ""}`
            };
        }
        
        return {
            name: "",
            url: "",
            query_engine: "",
            schema_engine: ""
        };
    }

    static async download(): Promise<void> {
        const binaries = ['schema', 'query'];
        const binDir = path.resolve(__dirname, "..", "bin");
        fs.mkdirSync(binDir, { recursive: true });

        for (const prefix of binaries) {
            try {
                console.log(`==> Empezando descarga para: ${prefix}`);
                const binaryInfo = this.get(prefix);
                console.log(`Descargando: ${binaryInfo.name}`);
                console.log(`URL: ${binaryInfo.url}`);

                if (!binaryInfo.name) {
                    throw new Error("Unsupported platform or architecture");
                }

                const tempZipPath = path.join(os.tmpdir(), `binary-${prefix}-${Date.now()}.zip`);
                const finalBinaryPath = path.join(binDir, binaryInfo.name);

                if (fs.existsSync(finalBinaryPath)) {
                    console.log(`⚠️ El binario ya existe, omitiendo: ${finalBinaryPath}`);
                    continue;
                }

                // Descargar el archivo ZIP
                await new Promise<void>((resolve, reject) => {
                    const file = fs.createWriteStream(tempZipPath);
                    
                    https.get(binaryInfo.url, (response: IncomingMessage) => {
                        console.log(`Respuesta HTTP para ${prefix}: ${response.statusCode}`);
                        
                        if (response.statusCode !== 200) {
                            file.close();
                            try { fs.unlinkSync(tempZipPath); } catch {}
                            reject(new Error(`Failed to download file: ${response.statusCode}`));
                            return;
                        }

                        response.pipe(file);
                        
                        file.on("finish", () => {
                            file.close();
                            resolve();
                        });
                        
                        file.on("error", (err: Error) => {
                            file.close();
                            try { fs.unlinkSync(tempZipPath); } catch {}
                            reject(err);
                        });
                        
                    }).on("error", (err: Error) => {
                        file.close();
                        try { fs.unlinkSync(tempZipPath); } catch {}
                        reject(err);
                    });
                });

                console.log(`Zip descargado para ${prefix}, extrayendo...`);

                // Extraer el archivo ZIP
                await new Promise<void>((resolve, reject) => {
                    let extracted = false;
                    
                    fs.createReadStream(tempZipPath)
                        .pipe(unzipper.Parse())
                        .on('entry', (entry: unzipper.Entry) => {
                            const fileName: string = entry.path;
                            const type: string = entry.type;
                            
                            console.log(`Encontrado en ZIP: ${fileName} (${type})`);
                            
                            if (type === 'File' && !extracted) {
                                extracted = true;
                                const writeStream = fs.createWriteStream(finalBinaryPath);
                                
                                entry.pipe(writeStream);
                                
                                writeStream.on('finish', () => {
                                    // Hacer el archivo ejecutable en sistemas Unix
                                    if (process.platform !== 'win32') {
                                        fs.chmodSync(finalBinaryPath, 0o755);
                                    }
                                    
                                    // Limpiar archivo temporal
                                    try { fs.unlinkSync(tempZipPath); } catch {}
                                    
                                    console.log(`Binario extraído y guardado: ${finalBinaryPath}`);
                                    resolve();
                                });
                                
                                writeStream.on('error', (err: Error) => {
                                    try { fs.unlinkSync(tempZipPath); } catch {}
                                    reject(err);
                                });
                            } else {
                                entry.autodrain();
                            }
                        })
                        .on('error', (err: Error) => {
                            try { fs.unlinkSync(tempZipPath); } catch {}
                            reject(err);
                        })
                        .on('close', () => {
                            if (!extracted) {
                                try { fs.unlinkSync(tempZipPath); } catch {}
                                reject(new Error(`No se encontró ningún archivo válido en el ZIP para ${prefix}`));
                            }
                        });
                });

                console.log(`==> Finalizó descarga y extracción para: ${prefix}`);

            } catch (error: unknown) {
                const errorMessage = error instanceof Error ? error.message : 'Error desconocido';
                console.error(`Error descargando binario ${prefix}:`, errorMessage);
                throw error; // Re-lanzar el error para que se pueda manejar externamente si es necesario
            }
        }
    }
}

export { Downloader };